import moment from 'moment-timezone';
import { SERVER_TIMEZONE } from '@ally/date-utils';
import { oneTime, SERVER_DATE_FORMAT } from '../constants';
import { RemoteStatus } from '../Remote';
function getMinDeliveryDate(_a) {
    var _b = _a.frequency, frequency = _b === void 0 ? oneTime : _b, transferSpeeds = _a.transferSpeeds, transferType = _a.transferType;
    if (transferType !== 'EXTERNAL')
        return moment.tz(SERVER_TIMEZONE);
    if (transferSpeeds.status !== RemoteStatus.Loaded)
        return moment.tz(SERVER_TIMEZONE);
    if (frequency !== oneTime) {
        var recurringSpeed = transferSpeeds.data.find(function (speed) { return speed.transferfrequency === 'Recurrence'; });
        return recurringSpeed
            ? moment.tz(recurringSpeed.deliveryDate, SERVER_DATE_FORMAT, SERVER_TIMEZONE)
            : moment.tz(SERVER_TIMEZONE);
    }
    var oneTimeSpeeds = transferSpeeds.data.filter(function (speed) { return speed.transferfrequency === 'OneTime Transfer'; });
    if (oneTimeSpeeds.length === 0)
        return moment.tz(SERVER_TIMEZONE);
    return moment.min(oneTimeSpeeds.map(function (speed) {
        return moment.tz(speed.deliveryDate, SERVER_DATE_FORMAT, SERVER_TIMEZONE);
    }));
}
export default getMinDeliveryDate;
//# sourceMappingURL=getMinDeliveryDate.js.map